import { render, staticRenderFns } from "./applicant.vue?vue&type=template&id=4f27ed2a"
import script from "./applicant.vue?vue&type=script&lang=js"
export * from "./applicant.vue?vue&type=script&lang=js"
import style0 from "./applicant.vue?vue&type=style&index=0&id=4f27ed2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports